import type { User } from '@takeshape/schema';
import simpleReducer from '../common/utils/simple-reducer.js';
import { DISMISS_MESSAGE, SHOW_MESSAGE } from './action-types.js';
import type { MessageAction } from './actions.js';
import type { MessageType } from './types.js';

export type MessagesState = {
  active: boolean;
  message: string;
  type: MessageType;
  user?: User;
};

export const initialState: MessagesState = {
  active: false,
  message: '',
  type: 'info'
};

export default simpleReducer(initialState, {
  [SHOW_MESSAGE](_state: MessagesState, { meta, payload }: MessageAction) {
    return {
      active: true,
      message: payload,
      type: meta?.type,
      user: meta?.user
    };
  },
  [DISMISS_MESSAGE](state: MessagesState) {
    return {
      ...state,
      active: false
    };
  }
});
